import{_ as a}from"./_rollupPluginBabelHelpers-87fa6da4.js";import{coreDefaultTheme as r}from"@kite-js/theme";var e=a(a({},r.shadow),{},{M:"0 3px 5px 0 rgba(26, 44, 100, 0.3)"});export{e as default};
